import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { Upload, Stethoscope, Zap } from "lucide-react";

const actions = [
  {
    title: "Upload Blood Test",
    description: "Add new lab results",
    icon: Upload,
    url: "BloodTests",
    color: "from-blue-500 to-blue-600",
  },
  {
    title: "Add Clinical Note",
    description: "Document patient visit",
    icon: Stethoscope,
    url: "ClinicalNotes",
    color: "from-green-500 to-green-600",
  },
];

export default function QuickActions() {
  return (
    <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-xl">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-slate-900">
          <Zap className="w-5 h-5 text-yellow-600" />
          Quick Actions
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {actions.map((action) => (
          <Link key={action.title} to={createPageUrl(action.url)}>
            <Button
              variant="ghost"
              className="w-full justify-start h-auto p-4 hover:bg-gradient-to-r hover:from-slate-50 hover:to-blue-50 group transition-all duration-300"
            >
              <div
                className={`p-2 rounded-lg bg-gradient-to-br ${action.color} mr-3 group-hover:scale-110 transition-transform duration-200`}
              >
                <action.icon className="w-4 h-4 text-white" />
              </div>
              <div className="text-left">
                <div className="font-medium text-slate-900">{action.title}</div>
                <div className="text-xs text-slate-500">
                  {action.description}
                </div>
              </div>
            </Button>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}
